import { Component } from '@angular/core';

@Component({
  selector: 'other-list-component',
  templateUrl: './other.list.component.html'
})
export class OtherListComponent { }
